import { DvirFormEdit } from "./DvirFormEdit";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import { DvirFormCreate } from "./DvirFormCreate";
import { DvirFormsList } from "./DvirFormsList";

export default {
  icon: ListAltOutlinedIcon,
  list: DvirFormsList,
  create: DvirFormCreate,
  edit: DvirFormEdit,
};
